var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceBillSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice-bill-svgrepo-com",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M88.086,0a1.379,1.379,0,0,0-1.379,1.379v14.48l9.658,0V18.2a1.774,1.774,0,0,0,1.554,1.79,1.725,1.725,0,0,0,1.894-1.716V1.724A1.724,1.724,0,0,1,101.538,0Z",
    transform: "translate(-83.261)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(3.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M88.086,0a1.379,1.379,0,0,0-1.379,1.379v14.48l9.658,0V18.2a1.774,1.774,0,0,0,1.554,1.79,1.725,1.725,0,0,0,1.894-1.716V1.724A1.724,1.724,0,0,1,101.538,0Z",
    transform: "translate(-86.707)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M418.268,0h0a1.724,1.724,0,0,0-1.724,1.724V4.141H419.3a.693.693,0,0,0,.693-.693V1.724A1.724,1.724,0,0,0,418.268,0",
    transform: "translate(-399.992)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M14.829,403.249h0a1.724,1.724,0,0,1-1.724-1.724v-2.414l-12.411,0A.693.693,0,0,0,0,399.8v1.724a1.724,1.724,0,0,0,1.724,1.724Z",
    transform: "translate(-0.001 -383.249)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M195.4,44.08h-4.138a.345.345,0,1,1,0-.69H195.4a.345.345,0,1,1,0,.69",
    transform: "translate(-183.331 -41.666)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M139.481,96.148h-8.966a.345.345,0,0,1,0-.69h8.966a.345.345,0,0,1,0,.69",
    transform: "translate(-124.999 -91.665)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M139.481,148.215h-8.966a.345.345,0,1,1,0-.69h8.966a.345.345,0,0,1,0,.69",
    transform: "translate(-124.999 -141.663)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M139.449,200.283h-8.934a.345.345,0,1,1,0-.69h8.934a.345.345,0,1,1,0,.69",
    transform: "translate(-124.998 -191.662)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M139.489,252.351h-8.975a.345.345,0,0,1,0-.69h8.975a.345.345,0,0,1,0,.69",
    transform: "translate(-124.997 -241.661)",
    fill: "#b0b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M139.5,304.419h-8.989a.345.345,0,1,1,0-.69H139.5a.345.345,0,1,1,0,.69",
    transform: "translate(-124.995 -291.66)",
    fill: "#b0b6bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceBillSvgrepoCom);
export default __webpack_public_path__ + "static/media/invoice-bill-svgrepo-com.5cf7fdfb6742b6c1c41bbcebd51bb683.svg";
export { ForwardRef as ReactComponent };